module.exports = __webpack_public_path__ + "img/logo.496dd3de.png";